export default __webpack_public_path__ + "static/media/Goat-logo-emails.6fc5b37b.png";